import { VFlex } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%"}},[_c('app-toolbar',{staticClass:"header"}),_c(VMain,[_c('transition',{attrs:{"name":"fade","mode":"out-in","appear":""}},[_c(VFlex,{staticClass:"d-flex fill-height align-md-center justify-center"},[_c('router-view')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }